import React from 'react';
import {
  translate as t,
} from 'admin-on-rest';
import TextRecord from '../FormInputs/TextRecord';
import PairInput from '../FormInputs/PairInput';

export const PAIR_TYPE = 'pair';
export const defaultPair = () => {
  const randomInteger = Math.floor(Math.random() * 1000);
  const now = new Date().getTime();
  return {
    id: `${now}${randomInteger}`,
    type: PAIR_TYPE,
  };
};

const TRANSLATION_PREFIX = 'resources.quizes.fields.questions';
const TRANSLATION_QUIZ_PREFIX = 'resources.quizes';

class PairForm extends React.Component {
  firstPairOnChange = (pair) => {
    this.change('pair1', pair);
  }
  secondPairOnChange = (pair) => {
    this.change('pair2', pair);
  }
  thirdPairOnChange = (pair) => {
    this.change('pair3', pair);
  }

  change = (key, value) => {
    const delta = {};
    delta[key] = value;
    this.props.onChange(delta, this.props.id);
  }

  render() {
    const {
      pair1, pair2, pair3,
      translate,
    } = this.props;

    return (
      <>
        <TextRecord
          label={translate(`${TRANSLATION_PREFIX}.type`)}
          value={translate(`${TRANSLATION_QUIZ_PREFIX}.questions.pair`)}
        />
        <PairInput
          pair={pair1}
          label={translate(`${TRANSLATION_PREFIX}.pair1`)}
          onChange={this.firstPairOnChange}
        />
        <br />
        <PairInput
          pair={pair2}
          label={translate(`${TRANSLATION_PREFIX}.pair2`)}
          onChange={this.secondPairOnChange}
        />
        <br />
        <PairInput
          pair={pair3}
          label={translate(`${TRANSLATION_PREFIX}.pair3`)}
          onChange={this.thirdPairOnChange}
        />
      </>
    );
  }
}

export default t(PairForm);
